//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './MeasurementImportSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/measurements/import-settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.MeasurementImportSettingsDto, unknown, Types.MeasurementImportSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MeasurementImportSettingsDto, unknown, Types.MeasurementImportSettingsDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'MeasurementImportSettingsClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

/**
 * Gets Measurement import settings for current tenant.
 */
export function useGetQuery<TSelectData = Types.MeasurementImportSettingsDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.MeasurementImportSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.MeasurementImportSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MeasurementImportSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MeasurementImportSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.MeasurementImportSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets Measurement import settings for current tenant.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.MeasurementImportSettingsDto | undefined) => Types.MeasurementImportSettingsDto, ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

/**
 * Gets Measurement import settings for current tenant.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MeasurementImportSettingsDto | undefined) => Types.MeasurementImportSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(): string {
  let url_ = getBaseUrl() + "/api/measurements/import-settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(): MutationKey {
  return trimArrayEnd([
      'MeasurementImportSettingsClient',
      'patch',
    ]);
}

/**
 * Patches Measurement import settings for current tenant.
 */
export function usePatchMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.MeasurementImportSettingsPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.MeasurementImportSettingsPatchDto, TContext> {
  const key = patchMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.MeasurementImportSettingsPatchDto) => Client.patch(dto),
    mutationKey: key,
  });
}